
import { modalBaseGetters } from '@/mixins/ModalStore';

export const state = () => { };

export const getters = Object.assign({}, modalBaseGetters, {
});
